








































import Vue from "vue";

import { PropsIsImagePb, PropsIsChatMessage } from "../../models/chat";

import JzChatMsg from "./JzChatMsg.vue";
import JzChatImgTimerDialog from "./JzChatImgTimerDialog.vue";
import JzContainer from "../layout/JzContainer.vue";
import JzButton from "../control/JzButton.vue";
import JzIcon from "../image/JzIcon.vue";

import IconClock from "../../assets/icons/transparent/Clock.svg";
import IconPlaceholder from "../../assets/icons/transparent/ImagePlaceholder.svg";
import { convertMillisecToTime } from "../../utils/time";

interface Props extends PropsIsImagePb, PropsIsChatMessage {
  // If true, the image can always be opened
  canAlwaysOpen: boolean;
  // Clock icon
  iconClock: string;
  // Placeholder to display why the image "hasn't started"
  iconPlaceholder: string;
  // Text for the start button in the message
  textBtnOpen: string;
  // Text for the timeout button in the message
  textBtnTimeout: string;
  // Pattern to display time:
  //    %M is replaced by minutes
  //    %S is replaced by seconds
  // no padding
  textDisplayTimePattern: string;
}

interface State {
  // True if the dialog is currently opened
  isOpened: boolean;
  // True if the user has clicked the "start" button, revealing the image
  isStarted: boolean;
  // True if time is up, user cannot open/see the image anymore
  isTimeUp: boolean;
}

interface Computed {
  activeImgUrl: string;
  btnText: string;
  canOpen: boolean;
  displayTime: string;
  isShowingPlaceholder: boolean;
}

interface Methods {
  // Open the dialog
  open: () => void;
  // Start to view
  start: () => void;
  // Close the dialog
  close: () => void;
  // Time's up!
  timeout: () => void;
}

/**
 * decreaseTimer period is far from being optimized but easier to read
 *
 * @emits started
 * @emits closed
 * @emits timeout
 */
export default Vue.extend<State, Methods, Computed, Props>({
  components: {
    JzButton,
    JzChatImgTimerDialog,
    JzChatMsg,
    JzContainer,
    JzIcon
  },

  props: {
    canAlwaysOpen: { type: Boolean, default: false },
    seconds: { type: Number, required: true },
    imgUrl: { type: String, required: true },
    captions: { type: String, required: true },
    iconClock: { type: String, default: IconClock },
    iconPlaceholder: { type: String, default: IconPlaceholder },
    avatarUrl: { type: String, default: undefined },
    iconClose: { type: String, default: undefined },
    textRemainingTime: { type: String, default: undefined },
    textStart: { type: String, default: undefined },
    textBtnOpen: { type: String, default: "Open" },
    textBtnTimeout: { type: String, default: "Time's Up" },
    textDisplayTimePattern: { type: String, default: "%M 分 %S 秒" },
    type: { type: String, default: "bot" }
  },

  data() {
    return {
      isOpened: false,
      isStarted: false,
      isTimeUp: false
    };
  },

  computed: {
    activeImgUrl() {
      return this.isShowingPlaceholder ? this.iconPlaceholder : this.imgUrl;
    },
    btnText() {
      return this.canOpen ? this.textBtnOpen : this.textBtnTimeout;
    },
    canOpen() {
      return this.canAlwaysOpen || !this.isTimeUp;
    },
    displayTime() {
      const time = convertMillisecToTime(1000 * this.seconds);
      const display = this.textDisplayTimePattern
        .replace("%M", time.minutes.toString())
        .replace("%S", time.seconds.toString());
      return display;
    },
    isShowingPlaceholder() {
      return !this.canAlwaysOpen && (this.isTimeUp || !this.isStarted);
    }
  },

  methods: {
    start() {
      this.isStarted = true;
    },

    close() {
      this.isOpened = false;
    },

    open() {
      this.isOpened = true;
    },

    timeout() {
      this.close();
      this.isTimeUp = true;
    }
  }
});
